import React, {Component} from "react";
import FormGroupSelectInput from "../formGroupSelectInput";
import Button from "../button";
import _ from "lodash";
import {withRouter} from "react-router";
import { LEGAL_ADVICE_TEXT } from "../../helpers/variables";
import CONTENT_STRINGS from "../../helpers/contentStrings";
import { FORM_GROUP_VARIANTS } from "../../helpers/formGroupVariants";
import { FormGroup } from "arag-ui-lib";
import { formatSolicitorOptionLabel } from "../../helpers/functions";

const getCaseTypesOptions = (caseTypes) => {
    return [{key: '', value: ''}, ...caseTypes.map(caseType => ({
        key: caseType.id,
        value: caseType.name
    }))]
};

const getSubCaseTypesOptions = (subCases, selectedCaseTypeId) => {
    return [{key: '', value: ''}, ..._.filter(subCases, item => {
        return  item.caseTypeId.toString() === selectedCaseTypeId
    }).map(item => ({key: item.id, value: item.name}))]
};

const getGroupSubCaseTypesOptions = (caseTypes, selectedCaseTypeId) => {
    const o = [];
    _.forEach(caseTypes, ctype => {
        if(ctype.id.toString() === selectedCaseTypeId){
            _.forEach(ctype.subCaseTypes, sctype => {
                o.push(sctype)
            })
        }
    });
    return [{key: '', value: ''},...o.map(item => {return {key: item.id, value: item.name}})];
};


class ReferralSettingsCopyForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            solicitorGroup: "",
            workSource: "",
            caseType: "",
            subCaseType: "",
        }
    }

    onGroupChange = (option) => {
        const groupId = option ? option.value.toString() : "";
        if(groupId !== ""){
            this.props.getSolicitorGroupCaseTypes(groupId);
        }
        this.setState({
            ...this.state,
            solicitorGroup: groupId,
            caseType: "",
            subCaseType: ""
        })
    };

    onCaseChange = (evt) => {
        this.setState({
            ...this.state,
            caseType: evt.target.value,
            subCaseType: ""
        })
    };

    onSubCaseChange = (evt) => {
        this.setState({
            ...this.state,
            subCaseType: evt.target.value
        })
    };

    onCopy = () => {
        this.props.changeReferralSettingsState({
            key: "selectedGroup",
            value: this.state.solicitorGroup
        });

        this.props.changeReferralSettingsState({
            key: "appType",
            value: this.state.solicitorGroup === "" ? "default" : "custom"
        });

        this.props.changeReferralSettingsState({
            key: "selectedCaseType",
            value: this.state.caseType
        });

        this.props.changeReferralSettingsState({
            key: "selectedSubCaseType",
            value: this.state.subCaseType
        });

        this.props.closeCopyModal();
    };

    render(){
        const {
            closeCopyModal,
            solicitorGroups,
            caseTypes,
            subCaseTypes,
            groupCaseAndSubTypes,
        } = this.props;

        const caseTypesOptions = this.state.solicitorGroup ?
            getCaseTypesOptions(groupCaseAndSubTypes) : getCaseTypesOptions(caseTypes);
        const subCaseTypesOptions =   this.state.solicitorGroup?
            getGroupSubCaseTypesOptions(groupCaseAndSubTypes, this.state.caseType) : getSubCaseTypesOptions(subCaseTypes, this.state.caseType);

        const solicitorGroupOptions = [{value: '', label: CONTENT_STRINGS.NONE}, ...solicitorGroups.map((group) => {
                return {value: group.id, label: group.name, aragProvider: group.aragProvider}
            }
        )];

        return (
            <form className={"form-horizontal"}>
                <FormGroup
                    labelSize={"col-sm-3"}
                    inputSize={"col-sm-6"}
                    label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}`}
                    variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
                    inputProps={{
                        instanceId: `${LEGAL_ADVICE_TEXT}Group`,
                        options: solicitorGroupOptions,
                        value: solicitorGroupOptions.find(o => o.value.toString() === this.state.solicitorGroup) || null,
                        onChange: this.onGroupChange,
                        formatOptionLabel: formatSolicitorOptionLabel,
                    }}
                />
                <FormGroupSelectInput
                    Label="Case Type"
                    LeftWrapper="col-sm-3"
                    Value={this.state.caseType}
                    Name="caseType"
                    HandleInputChange={this.onCaseChange}
                    Options={caseTypesOptions}
                    Required
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    SelectStyle={'form-control formGroupSelectInput-select'}
                />
                {subCaseTypesOptions.length > 1 && (
                    <FormGroupSelectInput
                        Label="Sub Case Type"
                        LeftWrapper="col-sm-3"
                        Value={this.state.subCaseType}
                        Name="subCaseType"
                        HandleInputChange={this.onSubCaseChange}
                        Options={subCaseTypesOptions}
                        CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                        SelectStyle={'form-control formGroupSelectInput-select'}
                    />
                )}
                <div className={"form-group"}>
                    <div className={"col-sm-6 col-sm-offset-3"}>
                        <Button
                            disabled={this.state.caseType === ""}
                            clickHandler={this.onCopy}
                            wrapper="btn-wrapper-forForms"
                            btnType="button"
                            btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Create New Based On Current"
                        />
                        <Button
                            wrapper="btn-wrapper-forForms"
                            btnType="button"
                            clickHandler={closeCopyModal}
                            btnStyle={'btn btn-primary btn-xs sharp blue'}
                            label="Cancel"/>
                    </div>
                </div>
            </form>
        )
    }
}

export default withRouter(ReferralSettingsCopyForm);